import { useEffect, useState } from 'react';
import careTeamApi from './careTeamApi';
import BulkCareTeamDialog from './BulkCareTeamDialog';
import { CARE_TEAM_FILTERS, plural } from './careTeamText';

// Patient lists: care-team filter + bulk "Assign nurse…" / "Remove nurse…" for the checked rows.
const CareTeamBulkBar = ({ selectedIds, filter, onFilterChange, onClear, onDone, defaultSlot = 'rpm' }) => {
    const [nurses, setNurses] = useState([]);
    const [mode, setMode] = useState(null);
    useEffect(() => {
        careTeamApi.people('nurse').then(setNurses).catch(() => setNurses([]));
    }, []);
    const count = selectedIds.length;
    return (
        <div className="d-flex align-items-center flex-wrap mb-2" style={{ gap: '8px' }} data-testid="care-team-bulk-bar">
            <select className="form-control form-control-sm" style={{ maxWidth: '220px' }} aria-label="Care team filter" value={filter} onChange={(e) => onFilterChange(e.target.value)}>
                {CARE_TEAM_FILTERS.map((f) => <option key={f.value} value={f.value}>{f.label}</option>)}
                {nurses.map((n) => <option key={n.id} value={`nurse:${n.id}`}>Assigned to {n.name}</option>)}
            </select>
            <span style={{ fontSize: '13px' }}>{plural(count, 'patient')} selected</span>
            <button type="button" className="btn btn-primary btn-sm" disabled={!count} onClick={() => setMode('assign')}>Assign nurse…</button>
            <button type="button" className="btn btn-outline-danger btn-sm" disabled={!count} onClick={() => setMode('remove')}>Remove nurse…</button>
            {count > 0 && <button type="button" className="btn btn-link btn-sm" onClick={onClear}>Clear selection</button>}
            <BulkCareTeamDialog
                show={!!mode}
                mode={mode || 'assign'}
                patientIds={selectedIds}
                defaultSlot={defaultSlot}
                onHide={() => setMode(null)}
                onDone={onDone}
            />
        </div>
    );
};

export default CareTeamBulkBar;
